/* Copyright (c) Trimble Inc. All rights reserved. */
import React, { useEffect } from "react";
import ProductDiscovery from "./ProductDiscovery";
import { useProductListController } from "../components/ProductList.controller";
import { Box } from "@material-ui/core";
import { Breadcrumbs } from "modus/components/generic-page-title/Breadcrumbs";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import ApplicationTypeService from "../services/ApplicationTypeService";
import { SET_APPLICATION_TYPES } from "store/actions/actions";
import { useDispatch } from "react-redux";

export const ProductPage: React.FC = () => {
  const dispatch = useDispatch();
  const { asyncResponse } = useProductListController();

  const [state, { subscribe }] = useAsyncAction(() =>
    ApplicationTypeService.getApplicationTypes()
  );

  useEffect(() => {
    subscribe();
  }, [subscribe]);

  useEffect(() => {
    if (!state) return;
    if (state.loaded && state.value !== undefined) {
      const data = state.value;
      dispatch({
        type: SET_APPLICATION_TYPES,
        payload: Array.isArray(data) ? data : null
      });
    } else if (state.error) {
      dispatch({ type: SET_APPLICATION_TYPES, payload: null });
    }
  }, [state, dispatch]);

  return (
    <Box m={2}>
      <Breadcrumbs pageTitle={"Products"} />
      <ProductDiscovery asyncResponse={asyncResponse} />
    </Box>
  );
};

export default ProductPage;
